/**
 * @deprecated This file contains static product data and is deprecated.
 * Use the useProducts hook from @/hooks/useProducts instead to fetch
 * products from the Supabase database.
 *
 * This file is kept for backward compatibility only.
 */

export const newArrivals = [
  {
    id: "1",
    name: "Cosmic Dreams T-Shirt",
    price: 9.000,
    image: "https://via.placeholder.com/500x500/3B82F6/FFFFFF?text=Cosmic+Dreams+T-Shirt",
    category: "T-Shirts",
    badge: "New",
    rating: 4.8,
  },
  {
    id: "2",
    name: "Abstract Art Hoodie",
    price: 18.500,
    image: "https://via.placeholder.com/500x500/EC4899/FFFFFF?text=Abstract+Art+Hoodie",
    category: "Hoodies",
    badge: "New",
    rating: 4.9,
  },
  {
    id: "3",
    name: "Motivational Quote Mug",
    price: 5.500,
    image: "https://via.placeholder.com/500x500/FBBF24/000000?text=Motivational+Quote+Mug",
    category: "Mugs",
    badge: "New",
    rating: 4.7,
  },
  {
    id: "4",
    name: "Nature Vibes Poster",
    price: 7.500,
    image: "https://via.placeholder.com/500x500/06B6D4/FFFFFF?text=Nature+Vibes+Poster",
    category: "Posters",
    badge: "New",
    rating: 4.6,
  },
];

export const popularProducts = [
  {
    id: "5",
    name: "Retro Wave T-Shirt",
    price: 8.500,
    image: "https://via.placeholder.com/500x500/3B82F6/FFFFFF?text=Retro+Wave+T-Shirt",
    category: "T-Shirts",
    rating: 4.9,
  },
  {
    id: "6",
    name: "Tech Geek Phone Case",
    price: 6.500,
    image: "https://via.placeholder.com/500x500/8B5CF6/FFFFFF?text=Tech+Geek+Phone+Case",
    category: "Phone Cases",
    rating: 4.8,
  },
  {
    id: "7",
    name: "Coffee Lover's Mug Set",
    price: 11.000,
    image: "https://via.placeholder.com/500x500/FBBF24/000000?text=Coffee+Lover+Mug+Set",
    category: "Mugs",
    rating: 4.7,
  },
  {
    id: "8",
    name: "Urban Style Hoodie",
    price: 16.500,
    image: "https://via.placeholder.com/500x500/EC4899/FFFFFF?text=Urban+Style+Hoodie",
    category: "Hoodies",
    rating: 4.9,
  },
];

export const saleProducts = [
  {
    id: "9",
    name: "Galaxy Print T-Shirt",
    price: 6.750,
    originalPrice: 11.000,
    image: "https://via.placeholder.com/500x500/3B82F6/FFFFFF?text=Galaxy+Print+T-Shirt",
    category: "T-Shirts",
    badge: "40% OFF",
    rating: 4.6,
  },
  {
    id: "10",
    name: "Minimalist Poster Collection",
    price: 5.600,
    originalPrice: 9.400,
    image: "https://via.placeholder.com/500x500/06B6D4/FFFFFF?text=Minimalist+Poster",
    category: "Posters",
    badge: "40% OFF",
    rating: 4.5,
  },
  {
    id: "11",
    name: "Premium Comfort Hoodie",
    price: 13.100,
    originalPrice: 20.600,
    image: "https://via.placeholder.com/500x500/EC4899/FFFFFF?text=Premium+Comfort+Hoodie",
    category: "Hoodies",
    badge: "35% OFF",
    rating: 4.8,
  },
  {
    id: "12",
    name: "Designer Sticker Pack",
    price: 3.400,
    originalPrice: 5.600,
    image: "https://via.placeholder.com/500x500/10B981/FFFFFF?text=Designer+Sticker+Pack",
    category: "Stickers",
    badge: "40% OFF",
    rating: 4.7,
  },
];

// Combined products array for lookups (like in wishlist)
export const products = [
  ...newArrivals,
  ...popularProducts,
  ...saleProducts,
];
